export enum TypeModelVisualization {
  MODEL_NAME = 1,
  MODEL_REFERENCE = 2,
  PROVIDER_REFERENCE = 3
}
